// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\n  font-family: \"Open Sans\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\nbody {\n  margin: 0;\n  padding: 0;\n}\n.content-wrapper {\n  margin-left: 70px;\n}\n.content-wrapper__expanded {\n  margin-left: 223px;\n}\n.st-permissions__container {\n  width: 100%;\n  -webkit-transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  padding: 55px 30px;\n}", ""]);
// Exports
module.exports = exports;
